import React from 'react'

import { branch } from 'baobab-react/higher-order'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import CategoryCard from 'components/paperplane/CategoryCard'
import SummaryCard from 'components/paperplane/SummaryCard'

import PredictionData from './PaperplanePredictionData.json'

const predictionMap = {
  "PROBABLE": 0,
  "CHALLENGING": 1,
  "RE-CONSIDER": 2,
}

const PaperplaneSummary = ({
  name,
  average_score,
  rankPercent,
  option1,
  option2,
}) => (
  <div className="paperplane-summary" id="paperplane-summary">
    <SectionContainer paddingBottom={80}>
      <Container next>
        <div className="paperplane-summary__greeting">
          <div className="paperplane-summary__greeting-text">
            <Typography component="h1" variant="title" className="text-variant-title-sm m-b-md">
              Hasil Cek Peluang SBMPTN
            </Typography>
            <Typography component="span" variant="subheading">
              Halo <strong>{name}!</strong> Berikut adalah hasil cek peluangmu:
            </Typography>
          </div>
          <div className="paperplane-summary__sm-box-wrapper">
            <SummaryCard title="Nilai rerata kamu adalah:" value={Math.round(average_score)} />
            <SummaryCard
              title="Ranking kamu termasuk:"
              value={`${(rankPercent < 1) ? 1 : Math.round(rankPercent)}%`}
              unit="Tertinggi"
              notes="Ranking ini didapat dari hasil perbandingan dengan rata-rata nasional UTBK 2019."
            />
          </div>
        </div>

        <div className="paperplane-summary__categories">
          <CategoryCard
            index="1"
            {...PredictionData[predictionMap[option1.statement]]}
            campus={option1.campus_name}
            major={option1.name}
            capacity={option1.capacity}
            interest={option1.previous_year_registrants}
            competitiveLevel={Math.round(option1.competitive_rate * 100.0)}
            rankScore={option1.top_score_rank}
          />

          <CategoryCard
            index="2"
            {...PredictionData[predictionMap[option2.statement]]}
            campus={option2.campus_name}
            major={option2.name}
            capacity={option2.capacity}
            interest={option2.previous_year_registrants}
            competitiveLevel={Math.round(option2.competitive_rate * 100.0)}
            rankScore={option2.top_score_rank}
          />
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .paperplane-summary {
          &__greeting {
            padding: 24px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          &__greeting-text {
            margin-bottom: 46px;
            :global(span) {
              color: #1A344F !important;
            }
          }
          &__sm-box-wrapper {
            display: flex;
            justify-content: space-between;
          }

          &__sm-box {
            width: 240px;
            padding: 16px;
            flex-basis: 50%;
            box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
            border-radius: 10px;
            color: #7d92a9;
            &:not(:first-child) {
              margin-left: 16px;
            }
          }

          :global(&__sm-box-content) {
            font-size: 42px !important;
            font-weight: bold;
            color: #00c2c9;
          }

          &__categories {
            display: flex;
          }

          @media screen and (max-width: 767px) {
            &__greeting {
              flex-direction: column;
            }
            &__greeting-text {
              margin: 0;
            }

            &__sm-box-wrapper {
              margin-top: 24px;
              flex-direction: column;
            }

            &__sm-box {
              width: auto;
            }

            &__categories {
              flex-direction: column;
            }
          }
        }
      `}
    </style>
  </div>
)

PaperplaneSummary.defaultProps = {
  rankPercent: 0,
  average_score: 0,
  option1: {
    name: '',
  },
  option2: {
    name: '',
  },
}

export { PaperplaneSummary }
export default branch({
  name: ['serverProps', 'currentUser', 'name'],
  average_score: ['serverProps', 'average_score'],
  rankPercent: ['serverProps', 'rank_percent'],
  option1: ['serverProps', 'option_1'],
  option2: ['serverProps', 'option_2'],
}, PaperplaneSummary)
